export default __webpack_public_path__ + "static/media/c51666ce47bac8296e109f36a77ff4831581600945678.6bc33cf6.webp";